<template>
  <div>
    <Header :under-nav="underNav" :sp-width="spWidth"></Header>
    <main id="main-style">
          <router-view :sp-width="spWidth" :under-nav="underNav"></router-view>
    </main>
    <footer :class="{hide:spWidth}">
      <p>© 2020 Tabi no Shiori</p>
    </footer>
  </div>
</template>

<script>
  import Header from './components/Header.vue';

  export default {
    components: {
      Header
    },
    data() {
      return {
        width: window.innerWidth,
      }
    },
    computed: {
      spWidth: function() {
        return this.width >= 500;
      },
      underNav() {
        return this.width < 500;
      },
      changeHeadTitle: {
        get() {
          return this.$store.getters.changeHeadTitle;
        },
        set(value) {
          this.$store.commit('changeHeadTitle', value);
        }
      },
    },
    methods: {
      resizeWidth: function() {
          this.width = window.innerWidth;
      }
    },
    mounted() {
      window.addEventListener('resize', this.resizeWidth);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeWidth);
    },
    watch: {
      '$route': function (to) {
        if(to.path === "/" | to.path === "/howto") {
          this.changeHeadTitle = true;
        } else {
          this.changeHeadTitle = false;
        }
      }
    }
  }

</script>

<style lang="scss">
  @import "./assets/scss/app.scss";
</style>
